import { heFetch } from './HeFetch';

export default class FeatureFlags {
    // Client-exposed Flagsmith flags of the logged-in member, evaluated by the BFF
    static async get() {
        return heFetch.get('/feature-flags');
    }
}
